import React, { useState, useEffect } from 'react';

import ServiceCard from '../components/ServiceCard';
import ImageSlider from '../components/ImageSlider';
import Loader from '../components/Loader';

import WelfareCategories from '../components/WelfareCategories';
import LatestRetrainings from '../components/LatestRetrainings';
import LatestNews from '../components/LatestNews';
import Recommendations from '../components/Recommendations';
import NotificationSlider from '../components/NotificationSlider';
import api from '../utils/api';
import { Link } from 'react-router-dom';




 
const Home = () => {

    const [featuredServices, setFeaturedServices] = useState([]);
     const [sliderItems, setSliderItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadData();
    }, []);


    const loadData = async () => {
        try {
            // Load slider data
            const sliderResp = await api.get('/slider');
            if (Array.isArray(sliderResp.data)) {
                const normalized = sliderResp.data
                    .filter((slide) => slide.inApp !== false)
                    .map((slide) => ({
                        ...slide,
                        id: slide._id,
                        order: Number(slide.order) || 0,
                    }));
                const sortedSlides = normalized.sort((a, b) => (a.order || 0) - (b.order || 0));
                setSliderItems(sortedSlides);
                try {
                    localStorage.setItem('app.slider', JSON.stringify(sortedSlides));
                } catch (cacheError) {
                    console.warn('Unable to cache slider data:', cacheError);
                }
            }

            // Load featured services
            const featuredResp = await api.get('/welfare/services', { params: { isFeatured: true } });
            if (Array.isArray(featuredResp.data)) {
                setFeaturedServices(featuredResp.data);
            }
        } catch (error) {
            console.error('Error loading data:', error);
        }
        setLoading(false);
    };





    if (loading) {
        return <Loader />;
    }

    return (
        <div className="main-container container pt-2" style={{}}>
            {/* search */}
            {/* <div className="row mb-3">
                <div className="col-12 overflow-hidden">
                    <div className="row">
                        <div className="col position-relative align-self-center">
                            <TextField
                                fullWidth
                                label="جستجو"
                                placeholder="جستجو در خدمات..."
                                value={searchQuery}
                                onChange={handleSearch}
                                sx={textFieldStyle}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Search color="action" />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </div>
                        <div className="col-auto align-self-center pb-3">
                            <button className="btn btn-light btn-44 filter-btn border-0 shadow-sm" style={{ borderRadius: '12px' }}>
                                <FilterList sx={{ fontSize: 24 }} />
                            </button>
                        </div>
                    </div>
                </div>
            </div> */}
            {/* high light */}
            <div className="row mb-4 align-items-center pe-3">
                <div className="col-4" style={{maxWidth:92, flex:'0 0 92px', paddingRight:0}}>
                    <Link to={`/Retraining`} className="text-decoration-none d-block">
                        <div
                            className="avatar avatar-70 rounded-18 mx-auto d-flex align-items-center justify-content-center shadow-sm "
                            style={{ backgroundColor: '#fff5f5', color: '#ff4d4f', width: 92, height: 92, maxHeight: 92, maxWidth: 92 }}
                        >
                            <img
                                src={'/assets/img/Retrainingx.png'}
                                alt="بازآموزی" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 12 }} />
                        </div>
                    </Link>
                </div>
                <div className="col-8" style={{flex:'1 1 0%', minWidth:0}}>
                    <NotificationSlider />
                </div>
            </div>
            {/* categories */}

            <WelfareCategories />
             <Recommendations />
            <ImageSlider slides={sliderItems} />
            <div className='mt-4'>
           <LatestNews limit={7} />
           </div>
            <LatestRetrainings />


            {/* products swiper */}
            {/* {allServices.length > 0 && (
                <div className="row mb-3">
                    <div className="col-12">
                     <h6>همه خدمات</h6>
                        <h6 className="mb-3">خدمات برگزیده</h6>
                    </div>
                    <div className="col-12 px-0">
                        <div className="swiper-container connectionwiper">
                            <div className="swiper-wrapper">
                                {allServices.map((service) => (
                                    <ServiceCard key={service._id} service={service}   />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )} */}

            {/* product grid */}
            <div className="row mb-2">
                <div className="col-12 mb-2">
                    <h6 className="mb-3">خدمات برگزیده</h6>
                </div>
                {featuredServices.length > 0 ? (
                    featuredServices.map((service) => (
                        <ServiceCard key={service._id} service={service} />
                    ))
                ) : (
                    <div className="col-12 text-center py-4">
                        <p className="text-muted">خدمتی یافت نشد</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Home;
